import { useEffect } from 'react'

function storeMarketingParamsInSession() {
  let params = new URLSearchParams(document.location.search)
  let mtm_cid = params.get('mtm_cid')
  if (mtm_cid) {
    sessionStorage.setItem('mtm_cid', mtm_cid)
    sessionStorage.setItem('referrer', document.referrer)
  }
}

export const MarketingParams = () => {
  useEffect(storeMarketingParamsInSession, [])
  return null
}
